import { 
  Box, Button, Flex, Select, InputGroup, UnorderedList, ListItem,
  InputLeftElement, Input, Heading, Text, Switch, TableContainer, Table,
  Thead, Tbody, Th, Tr, Td, GridItem, Image, Textarea, Modal, 
  ModalBody, ModalCloseButton, 
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter
} from "@chakra-ui/react";
    import { FaRegFile as FileIcon,FaTimes as CancelIcon } from "react-icons/fa";
  import { TopDisplay,UploadButton } from "../../../components";
  import { BsDownload as DownloadIcon } from "react-icons/bs";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState ,useEffect} from "react";
  // import styled from "@emotion/styled";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import { Formik,Form,Field } from "formik";
  import {TablePopUp} from '../../../components';
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import { BatchInvite } from "./Modal";
  import { Loader } from "../../../customs";
  import { FcInvite as InviteIcon} from "react-icons/fc";
  import apiCall from '../../../utils/apiCall';
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import ReactPaginate from 'react-paginate';
  import { useDropzone } from 'react-dropzone';
  import apiCallFormData from '../../../utils/apiFormDataCall';
  import { BsUpload as UploadIcon} from "react-icons/bs";
  import {
    Grid,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor,
  } from '@chakra-ui/react'
  import {useAtom,atom} from 'jotai'
  import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
  import { format } from "date-fns";
  import * as Yup from 'yup';
  import styled from "@emotion/styled";
  
  
  
  const src=`/public-assets/upload_icon.png`;
  
  const indexAtom = atom<number | null>(null);
  const list = [
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
  ]
  
  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
    &:hover > td:last-of-type{
      
      & > div{
        display: block;
      }
    }
    & > td > div.active{
      display: block;
    }
  `
  
  export default function UploadOldApplication() {
    const [hide,set_hide] = useState<boolean>(true);
    const [activeIndex] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);

    const [search,set_search] = useState('');
    const itemsPerPage = 100;
    const [pageNumber, setPageNumber] = useState(1);

    const { data, isLoading } = useQuery(
      ["all-induction", search, pageNumber],
      async () => {
        const response = await apiCall().get(
          `Exam/students/dueForInduction`,
          {
            params: {
              PageNumber: pageNumber,
              PageSize: itemsPerPage,
              searchQuery: search || "",
            },
          }
        );
        return response.data;
      },
      {
        keepPreviousData: true,
      }
    );

    const filter_data = data?.reportItems || [];
    const pageCount = data?.PageCount || 1;
    const totalCount = data?.TotalCount || 0;
    const itemOffset = (pageNumber - 1) * itemsPerPage;
    const endOffset = Math.min(pageNumber * itemsPerPage, totalCount);
    const currentItems = filter_data;

    const handleSearch = (e:any)=>{
      set_search(e.target.value);
      setPageNumber(1);
    }

    const handleReload = () => {
      set_search('');
      setPageNumber(1);
    };

    const handlePageClick = (event:any) => {
      setPageNumber(event.selected + 1);
    };


    const showUploadOldInducteeApplication = () =>{
      set_modal({
        header:'Upload Old Inductees Application',
        content:<UploadOldInducteeApplication />
      })
      set_open(true);
    }

    const showUploadOldInducteeSubject = () =>{
        set_modal({
          header:'Upload Old Inductee Subject',
          content:<UploadOldInducteeSubject />
        })
        set_open(true);
      }

      const showUploadOldStudentBioData = () =>{
        set_modal({
          header:'Upload Student Bio Data',
          content:<UploadStudentBioData />
        })
        set_open(true);
      }
      
    const showDownloadTemplate = () =>{
      set_modal({
        header:'Downoad Excel Template ',
        content:<ViewDownloadTemplate />
      })
      set_open(true);
    }
  
    return (
      <>
     {isLoading?<Loader />:
  
      <Box>
        <TopDisplay label="Old Inductee" button_array={[
              <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<UploadIcon/>}     variant="outline"
              colorScheme="var(--dark-green-color)"
              onClick={showUploadOldInducteeApplication}
            >Upload Old Inductee Application</Button>,
            <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<UploadIcon/>}     variant="outline"
              colorScheme="var(--dark-green-color)"
              onClick={showUploadOldInducteeSubject}
            >Upload Student Subject Results</Button>,
            <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<UploadIcon/>}     variant="outline"
            colorScheme="var(--dark-green-color)"
            onClick={showUploadOldStudentBioData}
          >Upload Old StudentBio Data</Button>,
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup h="40px" width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='gray.300' />
              </InputLeftElement>
              <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span
            style={{
              position: 'absolute',
              zIndex: '1',
              right: '10px',
              cursor: 'pointer',
              top: '12px'
            }}
            onClick={handleReload} // ✅ Reload logic
          >
            <ReloadIcon />
          </span>
            </InputGroup>
            <Button variant="outline"  bg="var(--white-color)" color="var(--darek-green-color)"  leftIcon={<DownloadIcon/>}  
            colorScheme="var(--dark-green-color)"
            onClick={showDownloadTemplate}
          >Select Uplod Template Type to Download</Button>,
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Students Application,subject & BioData Table</Heading>
            <Text m="0" fontSize=".8rem">Showing {totalCount === 0 ? 0 : itemOffset + 1} - {endOffset} of {totalCount}</Text>
          </Flex>
     {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
              <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>IsInvited</Th>
                <Th sx={HeadStyle}>HasApplied</Th>
                <Th sx={HeadStyle}>IsOldStudent</Th>
                <Th sx={HeadStyle}>Ismoved</Th>
                {/* <Th sx={HeadStyle}>NewMembershipNo</Th> */}
                <Th sx={HeadStyle}>Status</Th>

                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.StudentNo}>
                <Td sx={DataStyle}>{eCandidate.FirstName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.LastName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.StudentNo || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsInvitedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.HasAppliedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsOldStudent?'Yes': 'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsMovedToMembership ?'Yes':'No'}</Td>
                {/* <Td sx={DataStyle}>{eCandidate.FinalMembershipNo?'Yes':'No'}</Td> */}
                <Td sx={DataStyle}>{eCandidate.Status}</Td>
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                </Td>
              </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Pending Inductee'  
        }
        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />
  
        </StylePaginateBox>
  
      </Box>
  }
  </>
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `
  
  const sx={
    ':hover':{
      bg:'var(--content-background)'
    }
  }
  
  const Option = (props:any)=>{
    const index = props.index;
    const candidate= props.candidate;
    const [ind,set_index] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom)
    const onClick=()=>{
      if(index === ind){
        set_index(null);
        return;
      }
      set_index(index);
    }
    const handleShowProfile = () =>{
      set_index(null);
      set_modal({
        header:'View Details',
        content:<ViewProfile candidate={candidate} />
      })
      set_open(true);
    }

    useEffect(()=>{
      return ()=>set_index(null)
    },[])
    return(
      <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
             <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
            {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
            {/* <GridItem sx={sx} p="8px 4px" onClick={handleSingleInvite}>Send Invite</GridItem>  */}
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
    )
  }
  
  const ViewProfile = (props:any) =>{
    return(
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex align="center" gap="20px">
        {/* <Image
          src="/public-assets/profile.png"
          width="150px"
          height="150px"
          objectFit="contain"
          objectPosition="center"
          alt="profile"
        /> */}
        <Flex gap="20px">
          {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
          <Text width="150px"  fontWeight="500" color="var(--light-text)">First Name</Text>
          <Text> {props.candidate.FirstName}</Text>
        </Flex>
      </Flex>
      <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
       
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Last Name</Text>
          <Text fontWeight="500">{props.candidate.LastName || 'N/A'}</Text>
        </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">StudentNo</Text>
          <Text fontWeight="500">
            {props.candidate.StudentNo||'N/A'}
          </Text>
        </GridItem >
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">IsInvited</Text>
          <Text fontWeight="500">
            {props.candidate.IsInvitedForInduction?'Yes':'No'}
          </Text>
        </GridItem >
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">HasApplied</Text>
          <Text fontWeight="500">
            {props.candidate.HasAppliedForInduction?'Yes':'NO'}
          </Text>
        </GridItem >
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">IsOldStudent</Text>
          <Text fontWeight="500">
            {props.candidate.IsOldStudent? 'Yes': 'No'}
          </Text>
        </GridItem >
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">IsMoved</Text>
          <Text fontWeight="500">
            {props.candidate.IsMovedToMembership?'Yes': 'N/a'}
          </Text>
        </GridItem >
        {/* <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">NewMemberNo</Text>
          <Text fontWeight="500">
            {props.candidate.FinalMembershipNo || 'Not working'}
          </Text>
        </GridItem > */}
        {/* <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">Status</Text>
          <Text fontWeight="500">{props.candidate.Status || 'Pending'}</Text>
        </GridItem> */}
      </Grid>
    </Flex>
    )}
  
    const Label = styled.label``;  
  
   
  
  const UploadSchema = Yup.object({
    Inductee:Yup.mixed()
  
  });
    
    
  // const UploadOldInducteeApplication = (props:any) =>{
  //   // console.log({...props},'data')
  //   const queryClient = useQueryClient();
  //   const [,set_open] = useAtom(openAtom);
  //   const [,set_Nopen] = useAtom(openNAtom);
  //   const [,set_notification]= useAtom(notificationAtom);
    
  //   const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  //   const { getRootProps, getInputProps } = useDropzone({
  //     onDrop: (acceptedFiles) => {
  //       console.log(acceptedFiles.join(','),'files');
  //       setUploadedFiles(acceptedFiles);
  //       // Call your backend API endpoint to upload files
  //     },
  //   });
  
  //   const removeFile=(name:any)=>{
  //     setUploadedFiles((files:any[]) => files?.filter(eFile => eFile.name != name));
  //   }
  
  //   const {mutate:addUpdate,isLoading} = useMutation({
  //     mutationKey:['old-inductee'],
  //     mutationFn:async (data:FormData)=> {
  //       return await apiCallFormData().post(`/ExamUpload/uploadOldInducteeApplication`,data)},
  //     onSuccess:(data)=>{
  //       set_notification({
  //         type:'success',
  //         message:data?.data?.Message || 'Uploaded Successfully'
  //       })
  //       set_Nopen(true);
  //       queryClient.invalidateQueries({
  //         queryKey:['all-old-inductee']
  //       })
  //       setUploadedFiles([]);
  //     },
  //     onError(error:any, variables, context) {
  //       set_notification({
  //         type:'error',
  //         message:error?.data?.Message || 'Error Occured'
  //       })
  //       set_Nopen(true);
  //     },
  //     onSettled:()=>{
  //       set_open(false);
  //     }
  
  //   } )
  //   return (
  //     <>
  //       <Formik
  //           initialValues={{
              
  //             InducteeApplication: props.InducteeApplication || '',
  //           }}
  //           validationSchema={UploadSchema}
  //           onSubmit={(values:any) => {
  //             if(uploadedFiles.length > 0){
  //               const data =  new FormData();
  //               data.append('ExamApplication',uploadedFiles[0]);
              
  //               addUpdate(data);
  //             }
  //             else{
  //               set_notification({
  //                 type:'error',
  //                 message:'Select a file'
  //               })
  //               set_Nopen(true);
  //               return;
  //             }
              
  
  //           }}
  //         >
  //           {(formik:any)=>{
  //         const {errors} = formik;
  //         return (
  //             <Form>
  //               <Flex flexDir={"column"} align={"center"} gap="20px">             
  //                   {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
  //                 <Flex flexDir="column" gap="10px" w="100%">
                    
  //                     <Box>Upload Old Inductee Application:<br/></Box>             
  //                     <Box {...getRootProps()}>
  //                       <input {...getInputProps()} name="Inductee"  id="file" />
  //                       <Image
  //                         alt="upload document"
  //                         src={src}
  //                         w="100%"
  //                         h="150px"
  //                         objectFit="contain"
  //                         objectPosition="center"
  //                       />  
  //                       <UnorderedList sx={{p:'0',m:'0','listStyleType':'none'}}>
  //                       {uploadedFiles?.slice(0,1).map((file:any) => (
  //                         <ListItem align="center" gap="10px" as={Flex} sx={{p:'5p 0'}} fontSize="11px" key={file.name}><FileIcon />{file.name} <CancelIcon style={{marginLeft:'auto'}} onClick={()=>removeFile(file.name)} /></ListItem>
  //                       ))}
  //                     </UnorderedList>                   
  //                     </Box>
  //                 </Flex>
  //                 {/* <Field as={Input} multiple type='file' name="Document" /> */}
  //                 <Box>
  //                   {errors && Object.values(errors).map((eError:any,index:number)=> <Box color="red" key={index} >{eError}</Box>)}
  //                 </Box>
  //                 <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
  //                     {isLoading?"Loading":'Submit'}
  //                 </Button>
  //               </Flex>
  //             </Form>
  //           )}}
  //         </Formik>
  //     </>
  //   )
  // }
  

  // const UploadOldInducteeSubject = (props:any) =>{
  //   // console.log({...props},'data')
  //   const queryClient = useQueryClient();
  //   const [,set_open] = useAtom(openAtom);
  //   const [,set_Nopen] = useAtom(openNAtom);
  //   const [,set_notification]= useAtom(notificationAtom);
    
  //   const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  //   const { getRootProps, getInputProps } = useDropzone({
  //     onDrop: (acceptedFiles) => {
  //       console.log(acceptedFiles.join(','),'files');
  //       setUploadedFiles(acceptedFiles);
  //       // Call your backend API endpoint to upload files
  //     },
  //   });
  
  //   const removeFile=(name:any)=>{
  //     setUploadedFiles((files:any[]) => files?.filter(eFile => eFile.name != name));
  //   }
  
  //   const {mutate:addUpdate,isLoading} = useMutation({
  //     mutationKey:['old-inductees-subject'],
  //     mutationFn:async (data:FormData)=> {
  //       return await apiCallFormData().post(`/ExamUpload/uploadOldInducteeApplicationSubject2`,data)},
  //     onSuccess:(data)=>{
  //       set_notification({
  //         type:'success',
  //         message:data?.data?.Message || 'Uploaded Successfully'
  //       })
  //       set_Nopen(true);
  //       queryClient.invalidateQueries({
  //         queryKey:['all-induction']
  //       })
  //       setUploadedFiles([]);
  //     },
  //     onError(error:any, variables, context) {
  //       set_notification({
  //         type:'error',
  //         message:error?.data?.Message || 'OOOps! Error Occured'
  //       })
  //       set_Nopen(true);
  //     },
  //     onSettled:()=>{
  //       set_open(false);
  //     }
  
  //   } )
  //   return (
  //     <>
  //       <Formik
  //           initialValues={{
              
  //             InducteeApplicationSubject: props.InducteeApplicationSubject || '',
  //           }}
  //           validationSchema={UploadSchema}
  //           onSubmit={(values:any) => {
  //             if(uploadedFiles.length > 0){
  //               const data =  new FormData();
  //               data.append('ExamApplicationSubject',uploadedFiles[0]);
              
  //               addUpdate(data);
  //             }
  //             else{
  //               set_notification({
  //                 type:'error',
  //                 message:'Select a file'
  //               })
  //               set_Nopen(true);
  //               return;
  //             }
              
  
  //           }}
  //         >
  //           {(formik:any)=>{
  //         const {errors} = formik;
  //         return (
  //             <Form>
  //               <Flex flexDir={"column"} align={"center"} gap="20px">             
  //                   {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
  //                 <Flex flexDir="column" gap="10px" w="100%">
                    
  //                     <Box>Upload Old Inductee Application Subject:<br/></Box>             
  //                     <Box {...getRootProps()}>
  //                       <input {...getInputProps()} name="Inductee"  id="file" />
  //                       <Image
  //                         alt="upload document"
  //                         src={src}
  //                         w="100%"
  //                         h="150px"
  //                         objectFit="contain"
  //                         objectPosition="center"
  //                       />  
  //                       <UnorderedList sx={{p:'0',m:'0','listStyleType':'none'}}>
  //                       {uploadedFiles?.slice(0,1).map((file:any) => (
  //                         <ListItem align="center" gap="10px" as={Flex} sx={{p:'5p 0'}} fontSize="11px" key={file.name}><FileIcon />{file.name} <CancelIcon style={{marginLeft:'auto'}} onClick={()=>removeFile(file.name)} /></ListItem>
  //                       ))}
  //                     </UnorderedList>                   
  //                     </Box>
  //                 </Flex>
  //                 {/* <Field as={Input} multiple type='file' name="Document" /> */}
  //                 <Box>
  //                   {errors && Object.values(errors).map((eError:any,index:number)=> <Box color="red" key={index} >{eError}</Box>)}
  //                 </Box>
  //                 <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
  //                     {isLoading?"Loading":'Submit'}
  //                 </Button>
  //               </Flex>
  //             </Form>
  //           )}}
  //         </Formik>
  //     </>
  //   )
  // }
  const UploadOldInducteeApplication = (props: any) => {
    const queryClient = useQueryClient();
    const [, set_open] = useAtom(openAtom);
    const [, set_Nopen] = useAtom(openNAtom);
    const [, set_notification] = useAtom(notificationAtom);
  
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
    
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => {
        console.log(acceptedFiles, 'files');
        setUploadedFiles(acceptedFiles);
      },
    });
  
    const removeFile = (name: string) => {
      setUploadedFiles((files) => files.filter((file) => file.name !== name));
    };
  
    const { mutate: addUpdate, isLoading } = useMutation({
      mutationKey: ['old-inductee'],
      mutationFn: async (data: FormData) => {
        const response = await apiCallFormData().post(`/ExamUpload/uploadOldInducteeApplication`, data, {
          responseType: 'blob', // Ensures we handle file downloads properly
        });
        return response;
      },
      onSuccess: async (response) => {
        const contentType = response.headers['content-type'];
  
        if (contentType.includes('application/json')) {
          const data = await response.data.text();
          const parsedData = JSON.parse(data);
  
          set_notification({
            type: 'success',
            message: parsedData?.Message || 'Uploaded Successfully',
          });
        } else {
          const blob = new Blob([response.data], { type: contentType });
  
          // 🔹 Extract filename from content-disposition header
          let filename = 'DownloadedFile';
          const disposition = response.headers['content-disposition'];
          if (disposition) {
            const match = disposition.match(/filename="(.+?)"/);
            if (match) filename = match[1];
          }
  
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
  
          set_notification({
            type: 'success',
            message: 'Download Ready',
          });
        }
  
        set_Nopen(true);
        queryClient.invalidateQueries({ queryKey: ['all-old-inductee'] });
        setUploadedFiles([]);
      },
      onError: async (error: any) => {
        let errorMessage = 'Error Occurred';
        try {
          const text = await error.response.data.text();
          const parsedError = JSON.parse(text);
          errorMessage = parsedError?.Message || errorMessage;
        } catch {
          errorMessage = error?.message || errorMessage;
        }
  
        set_notification({
          type: 'error',
          message: errorMessage,
        });
  
        set_Nopen(true);
      },
      onSettled: () => {
        set_open(false);
      },
    });
  
    return (
      <>
        <Formik
          initialValues={{
            InducteeApplication: props.InducteeApplication || '',
          }}
          validationSchema={UploadSchema}
          onSubmit={() => {
            if (uploadedFiles.length > 0) {
              const data = new FormData();
              data.append('ExamApplication', uploadedFiles[0]);
              addUpdate(data);
            } else {
              set_notification({
                type: 'error',
                message: 'Select a file',
              });
              set_Nopen(true);
            }
          }}
        >
          {(formik: any) => {
            const { errors } = formik;
            return (
              <Form>
                <Flex flexDir="column" align="center" gap="20px">
                  <Flex flexDir="column" gap="10px" w="100%">
                    <Box>Upload Old Inductee Application:</Box>
                    <Box {...getRootProps()}>
                      <input {...getInputProps()} name="Inductee" id="file" />
                      <Image
                        alt="upload document"
                        src={src}
                        w="100%"
                        h="150px"
                        objectFit="contain"
                        objectPosition="center"
                      />
                      <UnorderedList sx={{ p: '0', m: '0', listStyleType: 'none' }}>
                        {uploadedFiles?.slice(0, 1).map((file) => (
                          <ListItem
                            align="center"
                            gap="10px"
                            as={Flex}
                            sx={{ p: '5px 0' }}
                            fontSize="11px"
                            key={file.name}
                          >
                            <FileIcon />
                            {file.name}
                            <CancelIcon style={{ marginLeft: 'auto' }} onClick={() => removeFile(file.name)} />
                          </ListItem>
                        ))}
                      </UnorderedList>
                    </Box>
                  </Flex>
                  <Box>
                    {errors && Object.values(errors).map((eError: any, index: number) => (
                      <Box color="red" key={index}>
                        {eError}
                      </Box>
                    ))}
                  </Box>
                  <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
                    {isLoading ? 'Loading...' : 'Submit'}
                  </Button>
                </Flex>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  };
  
  

  const UploadOldInducteeSubject = (props: any) => {
    const queryClient = useQueryClient();
    const [, set_open] = useAtom(openAtom);
    const [, set_Nopen] = useAtom(openNAtom);
    const [, set_notification] = useAtom(notificationAtom);
    const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => {
        setUploadedFiles(acceptedFiles);
      },
    });
  
    const removeFile = (name: any) => {
      setUploadedFiles((files: any[]) => files.filter((file) => file.name !== name));
    };
  
    const { mutate: addUpdate, isLoading } = useMutation({
      mutationKey: ["old-inductees-subject"],
      mutationFn: async (data: FormData) => {
        return await apiCallFormData().post(`/ExamUpload/uploadOldInducteeApplicationSubject2`, data, {
          responseType: "blob", // Ensures we properly handle file responses
        });
      },
      onSuccess: (response, variables, context) => {
        const contentType = response.headers["content-type"];
        if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          // Handle file download
          const blob = new Blob([response.data], { type: contentType });
          const contentDisposition = response.headers["content-disposition"];
          const filenameMatch = contentDisposition?.match(/filename="(.+)"/) || contentDisposition?.match(/filename\*=UTF-8''(.+)/);
          const filename = filenameMatch ? decodeURIComponent(filenameMatch[1]) : "FailedUploads.xlsx";
  
          // Trigger file download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
  
          set_notification({
            type: "error",
            message: "Some uploads failed. Download the error file for details.",
          });
        } else {
          // Handle normal JSON response
          const message = response?.data?.Message || "Uploaded Successfully";
          set_notification({ type: "success", message });
        }
  
        set_Nopen(true);
        queryClient.invalidateQueries({ queryKey: ["all-induction"] });
        setUploadedFiles([]);
      },
      onError: (error: any) => {
        set_notification({
          type: "error",
          message: error?.data?.Message || "Oops! Error Occurred",
        });
        set_Nopen(true);
      },
      onSettled: () => {
        set_open(false);
      },
    });
  
    return (
      <>
        <Formik
          initialValues={{
            InducteeApplicationSubject: props.InducteeApplicationSubject || "",
          }}
          validationSchema={UploadSchema}
          onSubmit={() => {
            if (uploadedFiles.length > 0) {
              const data = new FormData();
              data.append("ExamApplicationSubject", uploadedFiles[0]);
              addUpdate(data);
            } else {
              set_notification({
                type: "error",
                message: "Select a file",
              });
              set_Nopen(true);
            }
          }}
        >
          {(formik: any) => {
            const { errors } = formik;
            return (
              <Form>
                <Flex flexDir={"column"} align={"center"} gap="20px">
                  <Flex flexDir="column" gap="10px" w="100%">
                    <Box>Upload Old Inductee Application Subject:<br/></Box>
                    <Box {...getRootProps()}>
                      <input {...getInputProps()} name="Inductee" id="file" />
                      <Image
                        alt="upload document"
                        src={src}
                        w="100%"
                        h="150px"
                        objectFit="contain"
                        objectPosition="center"
                      />
                      <UnorderedList sx={{ p: "0", m: "0", listStyleType: "none" }}>
                        {uploadedFiles?.slice(0, 1).map((file: any) => (
                          <ListItem align="center" gap="10px" as={Flex} sx={{ p: "5px 0" }} fontSize="11px" key={file.name}>
                            <FileIcon />
                            {file.name}
                            <CancelIcon style={{ marginLeft: "auto" }} onClick={() => removeFile(file.name)} />
                          </ListItem>
                        ))}
                      </UnorderedList>
                    </Box>
                  </Flex>
  
                  {errors && Object.values(errors).map((eError: any, index: number) => (
                    <Box color="red" key={index}>
                      {eError}
                    </Box>
                  ))}
  
                  <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
                    {isLoading ? "Loading" : "Submit"}
                  </Button>
                </Flex>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  };
  
  

  interface UploadDetails {
    Message: string;
    [key: string]: any;
  }

//   const UploadStudentBioData = (props:any) =>{
//     // console.log({...props},'data')
//     const queryClient = useQueryClient();
// const [, set_open] = useAtom(openAtom);
// const [Nopen, set_Nopen] = useAtom(openNAtom); // Use Jotai
// const [, set_notification] = useAtom(notificationAtom);
// // const [uploadDetails, setUploadDetails] = useState(null);
// const [uploadDetails, setUploadDetails] = useState<UploadDetails | null>(null);


    
//     const [uploadedFiles, setUploadedFiles] = useState<any>([]);
//     const { getRootProps, getInputProps } = useDropzone({
//       onDrop: (acceptedFiles) => {
//         console.log(acceptedFiles.join(','),'files');
//         setUploadedFiles(acceptedFiles);
//       },
//     });
  
//     const removeFile=(name:any)=>{
//       setUploadedFiles((files:any[]) => files?.filter(eFile => eFile.name != name));
//     }
  
//     const { mutate: addUpdate, isLoading } = useMutation({
//       mutationKey: ['student-bio-data'],
//       mutationFn: async (data: FormData) => {
//         return await apiCallFormData().post(`/ExamUpload/uploadOldStudentBioData`, data);
//       },
//       onSuccess: (data) => {
//         set_notification({
//           type: 'success',
//           message: data?.data?.Message || 'BioData Uploaded Successfully'
//         });
    
//         // Store upload details for modal display
//         setUploadDetails(data?.data);
//         set_Nopen(true);
    
//         queryClient.invalidateQueries({
//           queryKey: ['student-bio-data']
//         });
    
//         setUploadedFiles([]);
//       },
//       onError: (error: any) => {
//         const errorMessage = error?.response?.data?.Message || 'OOOps! Error Occurred';
        
//         set_notification({
//           type: 'error',
//           message: errorMessage
//         });
    
//         set_Nopen(true);
//       },
//       onSettled: () => {
//         set_open(false);
//       }
//     });
//     <Modal isOpen={Nopen} onClose={() => set_Nopen(false)}>
//   <ModalOverlay />
//   <ModalContent>
//     <ModalHeader>Upload Successful</ModalHeader>
//     <ModalCloseButton />
//     <ModalBody>
//       <Text fontSize="lg" fontWeight="bold">
//         {uploadDetails?.Message || "Upload Completed!"}
//       </Text>
//       <Box mt={4}>
//         <Text>Additional Details:</Text>
//         <pre style={{ backgroundColor: "#f4f4f4", padding: "10px", borderRadius: "5px" }}>
//           {JSON.stringify(uploadDetails, null, 2)}
//         </pre>
//       </Box>
//     </ModalBody>
//     <ModalFooter>
//       <Button colorScheme="blue" onClick={() => set_Nopen(false)}>
//         Close
//       </Button>
//     </ModalFooter>
//   </ModalContent>
// </Modal>
  
    
//     return (
//       <>
//         <Formik
//             initialValues={{
              
//               StudentBioData: props.StudentBioData || '',
//             }}
//             validationSchema={UploadSchema}
//             onSubmit={(values:any) => {
//               if(uploadedFiles.length > 0){
//                 const data =  new FormData();
//                 data.append('StudentBioData',uploadedFiles[0]);
              
//                 addUpdate(data);
//               }
//               else{
//                 set_notification({
//                   type:'error',
//                   message:'Select a filled Upload template'
//                 })
//                 set_Nopen(true);
//                 return;
//               }
              
  
//             }}
//           >
//             {(formik:any)=>{
//           const {errors} = formik;
//           return (
//               <Form>
//                 <Flex flexDir={"column"} align={"center"} gap="20px">             
//                     {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
//                   <Flex flexDir="column" gap="10px" w="100%">
                    
//                       <Box>Upload Student Bio Data:<br/></Box>             
//                       <Box {...getRootProps()}>
//                         <input {...getInputProps()} name="StudentBioData"  id="file" />
//                         <Image
//                           alt="upload Biodata"
//                           src={src}
//                           w="100%"
//                           h="150px"
//                           objectFit="contain"
//                           objectPosition="center"
//                         />  
//                         <UnorderedList sx={{p:'0',m:'0','listStyleType':'none'}}>
//                         {uploadedFiles?.slice(0,1).map((file:any) => (
//                           <ListItem align="center" gap="10px" as={Flex} sx={{p:'5p 0'}} fontSize="11px" key={file.name}><FileIcon />{file.name} <CancelIcon style={{marginLeft:'auto'}} onClick={()=>removeFile(file.name)} /></ListItem>
//                         ))}
//                       </UnorderedList>                   
//                       </Box>
//                   </Flex>
//                   {/* <Field as={Input} multiple type='file' name="Document" /> */}
//                   <Box>
//                     {errors && Object.values(errors).map((eError:any,index:number)=> <Box color="red" key={index} >{eError}</Box>)}
//                   </Box>
//                   <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
//                       {isLoading?"Loading":'Submit'}
//                   </Button>
//                 </Flex>
//               </Form>
//             )}}
//           </Formik>
//       </>
//     )
//   }

// const UploadStudentBioData = (props: any) => {
//   const queryClient = useQueryClient();
//   const [, set_open] = useAtom(openAtom);
//   const [Nopen, set_Nopen] = useAtom(openNAtom);
//   const [, set_notification] = useAtom(notificationAtom);
//   const [uploadDetails, setUploadDetails] = useState<UploadDetails | null>(null);
//   const [uploadedFiles, setUploadedFiles] = useState<any>([]);

//   const { getRootProps, getInputProps } = useDropzone({
//     onDrop: (acceptedFiles) => {
//       setUploadedFiles(acceptedFiles);
//     },
//   });

//   const removeFile = (name: any) => {
//     setUploadedFiles((files: any[]) => files.filter((eFile) => eFile.name !== name));
//   };

//   const { mutate: addUpdate, isLoading } = useMutation({
//     mutationKey: ['student-bio-data'],
//     mutationFn: async (data: FormData) => {
//       return await apiCallFormData().post(`/ExamUpload/uploadOldStudentBioData`, data);
//     },
//     onSuccess: (data) => {
//       set_notification({ type: 'success', message: data?.data?.Message || 'BioData Uploaded Successfully' });
//       setUploadDetails(data?.data);
//       set_Nopen(true);
//       queryClient.invalidateQueries({ queryKey: ['student-bio-data'] });
//       setUploadedFiles([]);
//     },
//     onError: (error: any) => {
//       set_notification({ type: 'error', message: error?.response?.data?.Message || 'Oops! Error Occurred' });
//       set_Nopen(true);
//     },
//     onSettled: () => {
//       set_open(false);
//     },
//   });

//   return (
//     <>
//       <Formik
//         initialValues={{ StudentBioData: props.StudentBioData || '' }}
//         validationSchema={UploadSchema}
//         onSubmit={(values: any) => {
//           if (uploadedFiles.length > 0) {
//             const data = new FormData();
//             data.append('StudentBioData', uploadedFiles[0]);
//             addUpdate(data);
//           } else {
//             set_notification({ type: 'error', message: 'Select a filled Upload template' });
//             set_Nopen(true);
//           }
//         }}
//       >
//         {(formik: any) => {
//           const { errors } = formik;
//           return (
//             <Form>
//               <Flex flexDir={'column'} align={'center'} gap='20px'>
//                 <Flex flexDir='column' gap='10px' w='100%'>
//                   <Box>Upload Student Bio Data:<br /></Box>
//                   <Box {...getRootProps()}>
//                     <input {...getInputProps()} name='StudentBioData' id='file' />
//                     <Image
//                       alt='upload Biodata'
//                       src={src}
//                       w='100%'
//                       h='150px'
//                       objectFit='contain'
//                       objectPosition='center'
//                     />
//                     <UnorderedList sx={{ p: '0', m: '0', listStyleType: 'none' }}>
//                       {uploadedFiles.slice(0, 1).map((file: any) => (
//                         <ListItem
//                           align='center'
//                           gap='10px'
//                           as={Flex}
//                           sx={{ p: '5p 0' }}
//                           fontSize='11px'
//                           key={file.name}
//                         >
//                           <FileIcon />{file.name}
//                           <CancelIcon style={{ marginLeft: 'auto' }} onClick={() => removeFile(file.name)} />
//                         </ListItem>
//                       ))}
//                     </UnorderedList>
//                   </Box>
//                 </Flex>
//                 <Box>
//                   {errors && Object.values(errors).map((eError: any, index: number) => (
//                     <Box color='red' key={index}>{eError}</Box>
//                   ))}
//                 </Box>
//                 <Button type='submit' bg='var(--dark-green-color)' color='var(--white-color)' disabled={isLoading}>
//                   {isLoading ? 'Loading' : 'Submit'}
//                 </Button>
//               </Flex>
//             </Form>
//           );
//         }}
//       </Formik>

//       <Modal isOpen={Nopen} onClose={() => set_Nopen(false)}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Upload Successful</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Text fontSize='lg' fontWeight='bold'>
//               {uploadDetails?.Message || 'Upload Completed!'}
//             </Text>
//             <Box mt={4}>
//               <Text>Additional Details:</Text>
//               <pre style={{ backgroundColor: '#f4f4f4', padding: '10px', borderRadius: '5px' }}>
//                 {JSON.stringify(uploadDetails, null, 2)}
//               </pre>
//             </Box>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme='blue' onClick={() => set_Nopen(false)}>Close</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </>
//   );
// };


const UploadStudentBioData = (props: any) => {
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      console.log(acceptedFiles, 'files');
      setUploadedFiles(acceptedFiles);
    },
  });

  const removeFile = (name: string) => {
    setUploadedFiles((files) => files.filter((file) => file.name !== name));
  };

  const { mutate: addUpdate, isLoading } = useMutation({
    mutationKey: ['old-inductee'],
    mutationFn: async (data: FormData) => {
      const response = await apiCallFormData().post(`/ExamUpload/uploadOldStudentBioData`, data, {
        responseType: 'blob', // Ensures we handle file downloads properly
      });
      return response;
    },
    onSuccess: async (response) => {
      const contentType = response.headers['content-type'];

      if (contentType.includes('application/json')) {
        const data = await response.data.text();
        const parsedData = JSON.parse(data);

        set_notification({
          type: 'success',
          message: parsedData?.Message || 'Uploaded Successfully',
        });
      } else {
        const blob = new Blob([response.data], { type: contentType });

        // 🔹 Extract filename from content-disposition header
        let filename = 'DownloadedFile';
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const match = disposition.match(/filename="(.+?)"/);
          if (match) filename = match[1];
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        set_notification({
          type: 'success',
          message: 'Download Ready',
        });
      }

      set_Nopen(true);
      queryClient.invalidateQueries({ queryKey: ['all-old-inductee'] });
      setUploadedFiles([]);
    },
    onError: async (error: any) => {
      let errorMessage = 'Error Occurred';
      try {
        const text = await error.response.data.text();
        const parsedError = JSON.parse(text);
        errorMessage = parsedError?.Message || errorMessage;
      } catch {
        errorMessage = error?.message || errorMessage;
      }

      set_notification({
        type: 'error',
        message: errorMessage,
      });

      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    },
  });

  return (
    <>
      <Formik
        initialValues={{
          StudentBioData: props.StudentBioData || '',
        }}
        validationSchema={UploadSchema}
        onSubmit={() => {
          if (uploadedFiles.length > 0) {
            const data = new FormData();
            data.append('StudentBioData', uploadedFiles[0]);
            addUpdate(data);
          } else {
            set_notification({
              type: 'error',
              message: 'Select a file',
            });
            set_Nopen(true);
          }
        }}
      >
        {(formik: any) => {
          const { errors } = formik;
          return (
            <Form>
              <Flex flexDir="column" align="center" gap="20px">
                <Flex flexDir="column" gap="10px" w="100%">
                  <Box>Upload Students BioData:</Box>
                  <Box {...getRootProps()}>
                    <input {...getInputProps()} name="Inductee" id="file" />
                    <Image
                      alt="upload document"
                      src={src}
                      w="100%"
                      h="150px"
                      objectFit="contain"
                      objectPosition="center"
                    />
                    <UnorderedList sx={{ p: '0', m: '0', listStyleType: 'none' }}>
                      {uploadedFiles?.slice(0, 1).map((file) => (
                        <ListItem
                          align="center"
                          gap="10px"
                          as={Flex}
                          sx={{ p: '5px 0' }}
                          fontSize="11px"
                          key={file.name}
                        >
                          <FileIcon />
                          {file.name}
                          <CancelIcon style={{ marginLeft: 'auto' }} onClick={() => removeFile(file.name)} />
                        </ListItem>
                      ))}
                    </UnorderedList>
                  </Box>
                </Flex>
                <Box>
                  {errors && Object.values(errors).map((eError: any, index: number) => (
                    <Box color="red" key={index}>
                      {eError}
                    </Box>
                  ))}
                </Box>
                <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
                  {isLoading ? 'Loading...' : 'Submit'}
                </Button>
              </Flex>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};


  const DownloadSchema = Yup.object({
    templateType:Yup.string().required(),
  
  }); 
  const ViewDownloadTemplate = (props:any) =>{
    // console.log({...props},'data')
    
    const [,set_open] = useAtom(openAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    
    const {mutate:addUpdate,isLoading} = useMutation({
      mutationKey:[],
      mutationFn:async (templateType:string)=> {
        const headers = {
          "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        };
        return await apiCall().get(`/ExamUpload/download/${templateType}`,{
          headers,
          responseType:"blob"
  
        })},
      onSuccess:async(data:any)=>{
        //initial the download 
        //console.log(data,'download data')
        let file = data?.data;
        //console.log(file,'download file');
        if(file){
          const url = window.URL.createObjectURL(new Blob([file]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Inducteetemplate.xlsx");
          document.body.appendChild(link);
          link.click();
          //console.log(file,'data')
          set_notification({
            type:'success',
            message:data?.data?.Message || 'Template download Successfully'
          })
          set_Nopen(true);
        }
        else{
          set_notification({
            type:'error',
            message:'Oooops! Error Occured trying to download file'
          })
          set_Nopen(true);
        }
        
        
        
      },
      onError(error:any, variables, context) {
        set_notification({
          type:'error',
          message:error?.data?.Message || 'OOOps! Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:()=>{
        set_open(false);
      }
  
    } )
    return (
      <>
        <Formik
            initialValues={{
              
              templateType: props.InducteeApplication || '',
              Type: props.InducteeApplicationSubject || '',
              // templateType: props.StudentBioData || '',


            }}
            validationSchema={DownloadSchema}
            onSubmit={(values:any) => {
                if(values.templateType){
                  addUpdate(values.templateType);
                }
  
            }}
          >
            {(formik:any)=>{
          const {errors} = formik;
          return (
              <Form>
                <Flex flexDir={"column"} align={"center"} gap="20px">             
                    {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
                  <Flex flexDir="column" gap="10px" w="100%">
                    <Field as={Select} 
                      name="templateType"
                      placeholder="Select Template Type"
                    >
                      <option value="inductee">
                        inductee
                      </option>
                      <option value="InducteeApplication">
                        InducteeApplication
                      </option>
                      <option value="InducteeApplicationSubject2">
                        InducteeApplicationSubject
                      </option>
                      <option value="StudentBioData">
                        StudentBioData
                      </option>
  
                    </Field>
                    <Box color="red">
                      {errors && errors.templateType? errors.tempateType:''}
                    </Box>
                      
                  </Flex>
                  {/* <Field as={Input} multiple type='file' name="Document" /> */}
                  
                  <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
                      {isLoading?"Loading":'Submit'}
                  </Button>
                </Flex>
              </Form>
            )}}
          </Formik>
      </>
    )
  }